import CableReady from 'cable_ready'
import consumer from './consumer'

consumer.subscriptions.create({
  channel: 'CommentChannel',
  research_id: document.querySelector('meta[name=rid]')?.content
}, {
  connected () {},
  received (data) {
    if (data.cableReady) {
      console.log('operations', data.operations)
      CableReady.perform(data.operations)
    }
  }
})
